import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { setQuoteRequestLineQueryData } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";
import { setBatchReferenceLine } from "#modules/quoteRequestLines/infra/setBatchReferenceLine.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const useSetBatchReferenceLine = ({
  quoteRequestLineIdsInBatch,
}: {
  quoteRequestLineIdsInBatch: string[];
}) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: setBatchReferenceLine,
    onSuccess: (batch) => {
      quoteRequestLineIdsInBatch.forEach((quoteRequestLineId) => {
        setQuoteRequestLineQueryData(queryClient, quoteRequestLineId, (previous) =>
          previous ? { ...previous, batch } : previous,
        );
      });

      void queryClient.invalidateQueries({
        queryKey: queryKeys.optimizations.all,
      });
    },
    onError: (err: Error) => {
      showErrorToast({ title: "Une erreur est survenue lors du changement de lot" });
      errorHandler(err);
    },
  });

  return { setBatchReferenceLine: mutate, ...rest };
};
